export default __webpack_public_path__ + "static/media/seminar.52152912.png";